import {useRouter} from "vue-router";
import {ref} from "vue";

const upprMenus = [
  {sn: '100', nm: '서비스안내·신청', path: '/svc'},
  {sn: '200', nm: '고객센터', path: '/cscr'},
  /*{sn: '300', nm: '자료실', path: '/datrm'},*/
  /*{sn: '900', nm: '샘플', path: '/sample'},*/
];

const getUpprs = () => {
  return upprMenus;
}

const menus = [
  {sn: '101', upprSn: '100', nm: '세로이서비스', path: '/svc/seroi'},
  {sn: '102', upprSn: '100', nm: '노무서비스', path: '/svc/lbsc'},
  {sn: '103', upprSn: '100', nm: '제휴사 소개', path: '/svc/cprco'},
  {sn: '201', upprSn: '200', nm: '공지사항', path: '/cscr/nttm'},
  {sn: '202', upprSn: '200', nm: 'FAQ', path: '/cscr/faq'},
  {sn: '203', upprSn: '200', nm: '문의하기', path: '/cscr/inqry'},
  {sn: '204', upprSn: '200', nm: '원격지원', path: '/cscr/rmte-sprt'},
  // {sn: '801', upprSn: '800', nm: '대행업무', path: '/agency/stmn-agency'},
  /*
  {sn: '301', upprSn: '300', nm: '자료실', path: '/datrm'},
  {sn: '901', upprSn: '900', nm: '공통1', path: '/sample/sm001'},
  {sn: '902', upprSn: '900', nm: '공통2', path: '/sample/sm002'},
  */
];

const gets = (sn) => {
  return menus.filter(({upprSn}) => upprSn == sn);
}

const upprSn = ref('');
const setUpprSn = (sn) => {
  upprSn.value = sn;
}

const setMainScrn = (upprSn) => {
  setUpprSn(upprSn);

  const $router = useRouter();

  let nowPath = $router.currentRoute.value.path;

  const filters = gets(upprSn);
  const lnb = filters.find(({path}) => path == nowPath);

  if (!lnb) $router.replace({path: filters[0].path});

}

const useMenu = () => {
  return {
    upprSn,
    gets,
    getUpprs,
    setUpprSn,
    setMainScrn,
  }
}

export { useMenu };
